import { create } from "zustand"
import { persist } from "zustand/middleware"

export const useStoreToggleDrawer = create(persist((set) => ({
    categoryList: {},
    flatCategoryList: {},

    setCategoryList: (newCategoryList) => {
        //NOTE: Buat index untuk menghitung comulative index, untuk seluruh item
        let index = 0
        let data = Array.isArray(newCategoryList)
            ? newCategoryList.reduce((acc, newData) => {
                //NOTE: pengecekan apakah item memiliki categories lagi didalam category
                if (Array.isArray(newData.categories) && newData.categories.length > 0) {
                    //NOTE: Filter sub-category yang tidak memiliki produk
                    const updatedCategories = newData.categories
                        .filter((category) => Array.isArray(category.products) && category.products.length > 0)
                        .map((category) => {
                            return {
                                uuid_product_category: category.uuid_product_category,
                                categories: category.categories,
                                category_name: category.category_name,
                                url: category.url,
                                index: index++
                            };
                        });
                    //NOTE: Skip parent category jika semua sub-category kosong
                    if (updatedCategories.length === 0) return acc;
                    //NOTE: Rebuilt uland item dengan attribute yang dibutuhkan untuk rendering saja
                    acc.push({
                        uuid_product_category: newData.uuid_product_category,
                        categories: updatedCategories,
                        category_name: newData.category_name,
                        url: newData.url,
                    });
                } else {
                    //NOTE: Skip top-level category yang tidak memiliki produk
                    if (!Array.isArray(newData.products) || newData.products.length === 0) return acc;
                    acc.push({
                        uuid_product_category: newData.uuid_product_category,
                        categories: [],
                        category_name: newData.category_name,
                        index: index++,
                        url: newData.url,
                    });
                }
                return acc;
            }, [])
            : [];
        set({ categoryList: data });
    },
    setFlatCategoryList: (newCategories) => {
        let categories = [];
        newCategories.forEach((category, index) => {
            //NOTE: pengecekan apakah item memiliki categories lagi didalam category
            if (
                Array.isArray(category.categories) &&
                category.categories.length > 0
            ) {
                //NOTE: Ambil item dari dalam categories yang dibutuhkan untuk rendering saja
                category.categories.forEach((category2, index) => {
                    categories.push({
                        uuid_product_category: category2.uuid_product_category,
                        url: category2.url,
                        index: index,
                        category_name: category2.category_name,
                        menu_type: category2.menu_type,
                    });

                });
            } else {
                categories.push({
                    uuid_product_category: category.uuid_product_category,
                    url: category.url,
                    index: index,
                    category_name: category.category_name,
                    menu_type: category.menu_type,
                });
            }

            set({ flatCategoryList: categories })
        });
    }

}),
    {
        name: 'categoryList'
    }
))